import type {
  AccountUser,
  SuggestedMember,
} from '@frameio/graphql-client/generated';

export const isSelectable = (entry: SuggestedMember | AccountUser): boolean =>
  !('canView' in entry && entry.canView === true);
